module.exports = __webpack_public_path__ + "static/img/storlead_kf.5d09786.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/storlead_kf.png
// module id = aLWL
// module chunks = 47